import React, { useEffect, useRef, useState } from "react";
import Label from "../ui/Label";
import dayjs from "dayjs";
import { pubCall } from "../utils/PubSub";
import { ROUTES } from "../utils/Routes";
import { apiCall } from "../utils/Api";

export default function ConsoleClockPing() {

  const [currentTime, setCurrentTime] = useState(dayjs());

  const currentDay = useRef(dayjs().day());


  const continueToBMO = () => {
    apiCall("account/bizToBmo", { store_id: 298, corp_id: window.credentials.store_id }, (_s, _r) => {
      console.log("refetch...")
    })
  }


  useEffect(() => {

    if (window.bm_state.value === ROUTES.GLOBAL.MAINTENANCE) {
      return;
    }

    const intervalId = setInterval(() => {
      pubCall("extra.ping", { time: dayjs().unix() }, () => { });
      if (currentTime.format('YYYY-MM-DD') !== dayjs().format('YYYY-MM-DD')) {
        continueToBMO();
      }
      setCurrentTime(dayjs());
    }, 30000); // Update every second



    return () => clearInterval(intervalId); // Cleanup on unmount
  }, []);

  return(<></>);
  return (
    <Label>

      {currentTime.format('ddd MMM D YYYY h:mm A')}
    </Label>
  );
}